import { Flex, Box, Tag } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";
import { Modal } from "antd";

import PrimaryButton from "components/Button/PrimaryButton";
import useDeleteConta from "features/conta/hooks/useDeleteConta";
import useFindContaComplete from "features/conta/hooks/useFindContaComplete";
import { OperacaoEnum } from "core/resources/enums/conta";
import ContentDetalhesConta from "components/ContentDetalheConta";
import { useLoading } from "components/GlobalLoading";
import PopoverFooterModal from "./components/MaisOpcoesConta";
import { showConfirm2 } from "infra/helpers/alerta";
import { useEstornarConta } from "features/conta/hooks";

interface ModalContentContaProps {
  contaId?: string;
  isOpenModal: boolean;
  onClose: () => any;
  onEdit?: (id: string) => any;
  onLiquidar?: (id: string) => any;
  refetch?: () => any;
  operacao: OperacaoEnum;
}

export function ModalContentConta({
  operacao,
  contaId,
  isOpenModal,
  onClose,
  onEdit,
  onLiquidar,
  refetch,
}: ModalContentContaProps) {
  const {
    data,
    isLoading,
    isFetching,
    refetch: refetchDetalhe,
  } = useFindContaComplete(contaId);
  const { mutate: deleteConta, isLoading: isLoadingDelete } =
    useDeleteConta("/v1/cobranca");

  const { mutate: estornarConta, isLoading: isLoadingEstornar } =
    useEstornarConta("/v1/cobranca");

  useLoading(isLoading || isLoadingDelete || isFetching || isLoadingEstornar);

  return (
    <>
      <Modal
        centered
        destroyOnClose
        width="1000px"
        footer={
          <Flex flex={1} justifyContent="end" gap={4}>
            <PrimaryButton onClick={onClose}>Fechar</PrimaryButton>
          </Flex>
        }
        visible={isOpenModal}
        onCancel={onClose}
      >
        <Flex alignItems="center" gap={5} mb={4}>
          <Heading size="md" mt={-1}>
            <Flex>
              {data?.operacao === OperacaoEnum.Despesa ? "Despesa" : "Receita"}
              {data?.dataPagamento ? (
                <Box>
                  <Tag ml="16px" variant="solid" colorScheme="green">
                    Já Liquidada
                  </Tag>
                </Box>
              ) : null}
            </Flex>
          </Heading>

          <PopoverFooterModal
            onEdit={() => onEdit?.(contaId!)}
            onLiquidar={
              !data?.dataPagamento ? () => onLiquidar?.(contaId!) : undefined
            }
            onEstornar={
              data?.dataPagamento
                ? () =>
                    showConfirm2({
                      onOk: () =>
                        estornarConta(contaId!, {
                          onSuccess: () => refetchDetalhe(),
                        }),
                    })
                : undefined
            }
            onDelete={() => {
              showConfirm2({
                onOk: () => {
                  deleteConta([contaId!], {
                    onSuccess: () => {
                      setTimeout(() => {
                        onClose();
                        refetch?.();
                      }, 400);
                    },
                  });
                },
              });
            }}
            operacao={operacao}
            showVisualizar={!!data?.boleto?.linkBoleto}
            onVisualizar={() => {
              if (data?.boleto?.linkBoleto) {
                window.open(data.boleto.linkBoleto, "_blank");
              }
            }}
          />
        </Flex>

        {data ? (
          <ContentDetalhesConta data={data} operacao={data.operacao} />
        ) : null}
      </Modal>
    </>
  );
}
